import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowUpRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';
import ComfortSection from '../components/ComfortSection';
import FAQSection from '../components/FAQSection';
import { services } from '../data/mock';
import { useLang } from '../context/LanguageContext';

export default function ServicesPage() {
  const { t } = useLang();
  return (
    <>
      <Header />
      <PageHeader title={t('page.services')} breadcrumb={[t('page.crumb.services')]} />

      <section className="py-24 bg-white">
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <p className="section-eyebrow mb-4">{t('serv.pageEyebrow')}</p>
            <h2 className="text-[36px] md:text-[44px] leading-[1.1] font-extrabold text-[#14110f]">
              {t('serv.pageTitlePre')} <span className="text-[#f5b300]">{t('serv.pageTitleAccent')}</span>
            </h2>
            <p className="mt-5 text-[15.5px] text-neutral-600 leading-relaxed">{t('serv.pageDesc')}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((s, i) => {
              const Icon = Icons[s.icon] || Icons.Sparkles;
              const featured = i % 4 === 0;
              return (
                <div
                  key={s.id}
                  className={`group relative rounded-xl p-8 transition-all duration-300 hover:-translate-y-1.5 overflow-hidden ${
                    featured
                      ? 'bg-[#4a2e1a] text-white shadow-[0_25px_55px_-25px_rgba(74,46,26,0.6)]'
                      : 'bg-[#faf6ec] hover:bg-[#4a2e1a] hover:text-white shadow-[0_18px_45px_-25px_rgba(20,17,15,0.15)]'
                  }`}
                >
                  <div className="absolute -top-12 -right-12 w-44 h-44 rounded-full bg-[#f5b300]/8" />
                  <div className={`w-16 h-16 rounded-lg flex items-center justify-center mb-7 ${featured ? 'bg-[#f5b300]' : 'bg-[#f5b300]/20 group-hover:bg-[#f5b300]'}`}>
                    <Icon className={`w-8 h-8 ${featured ? 'text-[#14110f]' : 'text-[#c89200] group-hover:text-[#14110f]'}`} strokeWidth={1.7} />
                  </div>
                  <h3 className={`text-[20px] font-bold mb-3 ${featured ? 'text-white' : 'text-[#14110f] group-hover:text-white'}`}>
                    {t(`service.${s.id}.title`)}
                  </h3>
                  <p className={`text-[14px] leading-relaxed mb-7 ${featured ? 'text-white/70' : 'text-neutral-500 group-hover:text-white/70'}`}>
                    {t(`service.${s.id}.desc`)}
                  </p>
                  <Link to="/book" className={`inline-flex items-center gap-1.5 text-[13.5px] font-semibold uppercase tracking-wide ${featured ? 'text-[#f5b300]' : 'text-[#c89200] group-hover:text-[#f5b300]'}`}>
                    {t('cta.talkToAdvisor')} <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-0.5 transition-transform" />
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <ComfortSection />
      <FAQSection />
      <Footer />
    </>
  );
}
